import { useState } from "react";
import { HiOutlinePlus, HiOutlineMinus } from "react-icons/hi";

export default function FAQSection({ content }) {
  const [openIndex, setOpenIndex] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [formData, setFormData] = useState({ name: "", email: "", question: "" });
  const [submitted, setSubmitted] = useState(false);
  const [showAll, setShowAll] = useState(false); // <-- Add this line

  const togglePanel = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const filteredFAQs = content.faq.filter(
    (faq) =>
      faq.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
      faq.answer.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Limit to 5 unless showAll is true
  const displayedFAQs = showAll ? filteredFAQs : filteredFAQs.slice(0, 5);

  const handleInputChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: Replace with API call or email integration
    console.log("FAQ Submission:", formData);
    setSubmitted(true);
    setFormData({ name: "", email: "", question: "" });
  };

  return (
    <section id="faq" className="bg-white dark:bg-gray-900 pt-16 pb-20">
      <div className="container max-w-5xl px-6 mx-auto">
        <h1 className="text-3xl font-extrabold text-center text-gray-800 lg:text-4xl dark:text-white">
          Frequently Asked Questions
        </h1>
        <p className="mt-4 text-center text-gray-500 dark:text-gray-400 text-base max-w-2xl mx-auto">
          Got a question? Search or scroll through common inquiries below.
        </p>

        {/* 🔍 Search */}
        <div className="mt-8 mb-6 max-w-2xl mx-auto">
          <input
            type="text"
            placeholder="Search questions..."
            className="w-full px-4 py-3 border border-gray-300 dark:border-gray-700 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-800 dark:text-white"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {/* FAQ List */}
        <div className="space-y-4">
          {displayedFAQs.length > 0 ? (
            displayedFAQs.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={index}
                  className="group border border-gray-200 dark:border-gray-700 rounded-lg shadow-sm overflow-hidden transition-all duration-300 hover:bg-gray-50 dark:hover:bg-gray-800"
                >
                  <button
                    onClick={() => togglePanel(index)}
                    className="w-full flex justify-between items-center px-6 py-4 text-left text-gray-800 dark:text-gray-200 font-medium text-lg focus:outline-none"
                  >
                    <span>{faq.question}</span>
                    <span className="text-xl">
                      {isOpen ? <HiOutlineMinus /> : <HiOutlinePlus />}
                    </span>
                  </button>
                  <div
                    className={`px-6 pb-4 text-gray-600 dark:text-gray-400 text-base transition-all duration-300 ease-in-out ${
                      isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0 overflow-hidden"
                    }`}
                  >
                    {faq.answer}
                  </div>
                </div>
              );
            })
          ) : (
            <p className="text-center text-gray-500 dark:text-gray-400 mt-6">
              No results found.
            </p>
          )}
        </div>

        {/* Show More / Show Less Button */}
        {filteredFAQs.length > 5 && (
          <div className="flex justify-center mt-6">
            <button
              className="px-6 py-2 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition"
              onClick={() => setShowAll((prev) => !prev)}
            >
              {showAll ? "Show Less" : `Show More (${filteredFAQs.length - 5} more)`}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
